import "../../styles/CommonButton.scss";

const CommonButton = ({
  children,       // button text
  type = "primary", // primary / secondary / custom
  onClick,
  fullWidth = true,
  icon,           // optional icon
  disabled = false
}) => {
  return (
    <button
      className={`btn ${type}`}
      onClick={onClick}
      style={{ width: fullWidth ? "100%" : "auto" }}
      disabled={disabled}
    >
      {icon && <span className="btn-icon">{icon}</span>}
      {children}
    </button>
  );
};

export default CommonButton;
